import React, { useEffect, useState } from "react";
import { Box, Button, Grid, TextField, Typography } from "@mui/material";

import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useGlobal from "../../../util/Global";
import Accountservice from "../../../service/Core/AccountService";
import StorageUtils from "../../../ui/StorageUtils";
import EbasvuruTenantservice from "../../../service/Ebasvuru/EbasvuruTenantService";
import ApiUrl from "../../../service/ApiUrl";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { id } from "date-fns/locale";
import useQuery from "../../../util/useQuery";
import useMessage from "../../../util/useMessagev2";
import { getIPAddress, getLocalIP } from "../../../util/GeneralFunc";
import { fontStack } from "../../../themes/default";


const schema = yup.object().shape({
    cepTel: yup
        .string()
        .required("Lütfen telefonunuzu giriniz")
        .matches(/^5\d{9}$/, "Lütfen telefonunuzu (5xxxxxxxxx) şeklinde giriniz")
});

const CepTelConfirm = () => {

    const { t } = useGlobal();
    const history = useHistory();
    const showMessage = useMessage();
    const [adayIp, setIp] = useState();

    const goTo = (props) => {
        history.push(`/${props.page}`);
    }

    const query = useQuery();
    const id = query.get("id");


    const { register, handleSubmit, trigger, formState: { errors, isValid } } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange"
    })

    useEffect(() => {
        let isMounted = true; // Track mount state

        const adayUser = StorageUtils.get("aday");

        if (adayUser) {
            Accountservice.loginAsAday({ tenant: adayUser.tenantKey })
                .then((res) => {
                    if (isMounted && res?.token) {
                        EbasvuruTenantservice.setToken(res.token);
                    }
                })
                .catch((err) => console.error("Login failed:", err));
        }

        getLocalIP().then((ip) => {
            if (isMounted) setIp(ip);
        });

        return () => {
            isMounted = false; // Cleanup on unmount
        };
    }, []);



    const onSubmit = async (data) => {
        var adayRes = await EbasvuruTenantservice.baseget({
            endPoint: ApiUrl.publicEndpoint.AdayIdxRoot,
            data: { cepTel: data.cepTel }
        });


        if (adayRes && adayRes.isSuccess && adayRes.resultObject[0]) {

            var aday = adayRes.resultObject[0];
            var res = await EbasvuruTenantservice.SendSMS(
                {
                    aday: {
                        adayId: aday.id,
                        cepTel: data.cepTel,
                        tCKN: aday.tcKimlikNo,
                        ad: aday.ad,
                        Soyad: aday.soyad,

                    },
                    tel: data.cepTel,
                    adayIPAdresi: adayIp,
                    iletisimSenaryosu: 1, // LoginOnayKoduSMS
                });

            if (res && res.isSuccess) {
                goTo({ page: 'adayonaykodu' });
            } else {
                showMessage.error(t('message.FailedToSendSMSToAday'));
            }

            const adayUser = StorageUtils.get("aday");

            StorageUtils.save("aday",
                {
                    IAPId: id,
                    cepTel: data,
                    adayIp: adayIp,
                    sendTime: Date.now(),
                    ...adayUser,
                    ...aday
                }
            );
        } else {

            const adayUser = StorageUtils.get("aday");

            StorageUtils.save("aday",
                {
                    cepTel: data.cepTel,
                    adayIp: adayIp,
                    ...adayUser,
                }
            );

            goTo({ page: 'adaykimlikbilgisi' });
        }
    }

    useEffect(() => {
        trigger(); // 👈 Triggers validation on mount
    }, [trigger]);


    return (
        <Box
            component="form"
            onSubmit={handleSubmit(onSubmit)}
            sx={{ display: "flex", justifyContent: "center", alignItems: "center", padding: 5 }}>
            <Grid container spacing={4} maxWidth="90%" sx={{ alignItems: "center" }}>

                <Grid item xs={12} sm={12} >
                    <img
                        src="/securitas-logo-forwhitebackground.svg" // Replace with actual image path
                        style={{ width: "100px", borderRadius: "8px" }}
                    />
                    <span style={{ marginleft: "15px", color: "#888888", fontsize: "20px" }}>
                        {t("title.EbasvuruPortal")}
                    </span>
                </Grid>

                <Grid item sx={12}>
                    <Grid container spacing={5} >
                        <Grid item xs={12} sm={12} md={12} lg={7} sx={{ textAlign: 'center' }} >
                            <img
                                src="/sec-login-idari.png" // Replace with actual image path
                                alt={t("title.SecuritasTeam")}
                                style={{
                                    width: "40vw",

                                    height: 'auto',

                                }}
                            />
                        </Grid>

                        {/* Right Side - Form */}
                        <Grid item xs={12} sm={12} md={12} lg={5} sx={{ textAlign: "left" }} >
                            <Grid container sx={{ marginleft: 10 }} >
                                <Grid item xs={12}>
                                    <Typography style={{ fontWeight: 400, color: "#53575B", fontSize: '1.25rem' }}>
                                        {t("title.head1")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography sx={{ color: "red", fontSize: '1.1rem' }}>
                                        {t("title.head2")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="h5" sx={{
                                        fontWeight: 800,
                                        color: "red",
                                        fontSize: '20px',
                                        fontFamily: fontStack
                                    }}                                    >
                                        {t("title.head3")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="h6" sx={{ color: "#53575B", fontWeight: 900, fontSize: '1.25rem', fontFamily: fontStack }}>
                                        {t("title.head4")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sx={{ mt: 5 }}>
                                    <Typography variant="caption" sx={{ color: "#949494", fontsize: '1rem', padding: 0 }}>

                                        {t("title.cepTelefon")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={7} md={7} lg={8} >
                                    <TextField
                                        margin="normal"
                                        variant="outlined"
                                        placeholder="(5xxxxxxxxx)"
                                        fullWidth
                                        sx={{ mt: 0 }}
                                        {...register("cepTel")}
                                        error={!!errors.cepTel}
                                        helperText={errors.cepTel?.message}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={7} md={7} lg={8} >
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        sx={{ bgcolor: "#c00" }}
                                        type="submit"
                                        disabled={!isValid}
                                    >
                                        {t("action.girisKoduAl")}
                                    </Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <span style={{ color: "#666", fontSize: 11 }}>
                                        {t("title.tailer1")}
                                    </span>
                                </Grid>
                                <Grid item xs={12}>
                                    {/* Suggestion Button */}
                                    <Button
                                        variant="contained"
                                        size="small"
                                        sx={{
                                            mt: 1,
                                            bgcolor: "#c00",
                                            fontSize: 10,
                                            width: 'fit-content',
                                        }}
                                    >
                                        {t("title.onerTalep")}
                                    </Button>

                                </Grid>
                            </Grid>


                        </Grid>
                    </Grid>
                </Grid>

                {/* Left Side - Image */}





            </Grid>
        </Box >
    );
};

export default CepTelConfirm;
